var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { CardAdvancement, CardGrade, } from '@cta-portal/webapp-common/lib/api/schema';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useCallback, useContext, useEffect, useState } from 'react';
import { MarketDetailsTab } from '../../app/router/config';
import cardTypeIcon from '../../assets/images/icons/common/icon-card-type-gold.png';
import artistIcon from '../../assets/images/icons/common/icon-edit-gold.png';
import { CurrencyContext } from '../../context/currency';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol } from '../../data/currency-tokens/currency-tokens';
import ariseCoinData from '../../data/products/arise-coins.json';
import artistsData from '../../data/products/artists.json';
import cardsData from '../../data/products/cards.json';
import chestsData from '../../data/products/chests.json';
import mintPassesData from '../../data/products/mint-passes.json';
import presalePacksData from '../../data/products/presale-packs.json';
import presaleTicketsData from '../../data/products/presale-tickets.json';
import shardsData from '../../data/products/shards.json';
import souvenirCardsData from '../../data/products/souvenir-cards.json';
import { appEnv } from '../../env';
import { SortDirection, TokenType } from '../../types/common';
import { DialogType } from '../../types/dialogs';
import { sleep } from '../../utils/async';
import { checkIfWalletAsEnoughCurrency } from '../../utils/balances';
import { advancementAssets, elementAssets, factionAssets, gradeAssets, rarityAssets, } from '../../utils/cards-metadata-assets';
import { getAssetFloorPrice, getImxOrders } from '../../utils/imx-orders';
import { generateCardImgUrl, generatePathFromEnum, generateSouvenirCardImgUrl, sortedElements, } from '../../utils/products';
import { getFormatedSupply } from '../../utils/supply';
import { useImxActions } from '../imx/use-imx-actions';
export function useProduct(type, id, filters, tab) {
    var t = useI18n().t;
    var setImxLoading = useContext(LoadingContext).setImxLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, balances = _a.balances, selectedWallet = _a.selectedWallet, localWalletAddress = _a.localWalletAddress, fees = _a.fees, getBalances = _a.getBalances;
    var _b = useContext(CurrencyContext), usdcAddress = _b.usdcAddress, imxClient = _b.imxClient, queue = _b.queue, parseCurrencyQuantity = _b.parseCurrencyQuantity;
    var imxActions = useImxActions();
    var _c = useState(type === TokenType.CARD ? cardsData.find(function (card) { return card.ian === id; }) : undefined), productCard = _c[0], setProductCard = _c[1];
    var _d = useState(type === TokenType.MINT_PASS ? mintPassesData.find(function (mintPass) { return mintPass.key === id; }) : undefined), productMintPass = _d[0], setProductMintPass = _d[1];
    var _e = useState(type === TokenType.PRESALE_PACK ? presalePacksData.find(function (presalePack) { return presalePack.key === id; }) : undefined), productPresalePack = _e[0], setProductPresalePack = _e[1];
    var _f = useState(type === TokenType.PRESALE_TICKET
        ? presaleTicketsData.find(function (presaleTicket) { return presaleTicket.key === id; })
        : undefined), productPresaleTicket = _f[0], setProductPresaleTicket = _f[1];
    var _g = useState(type === TokenType.CHEST ? chestsData.find(function (chest) { return chest.key === id; }) : undefined), productChest = _g[0], setProductChest = _g[1];
    var _h = useState(type === TokenType.SHARD ? shardsData.find(function (shard) { return shard.key === id; }) : undefined), productShard = _h[0], setProductShard = _h[1];
    var _j = useState(type === TokenType.SOUVENIR_CARD
        ? souvenirCardsData.find(function (souvenirCard) { return souvenirCard.id.toString() === id; })
        : undefined), productSouvenirCard = _j[0], setProductSouvenirCard = _j[1];
    var _k = useState(type === TokenType.ARISE_COIN ? ariseCoinData.find(function (ariseCoin) { return ariseCoin.rarity === id; }) : undefined), productAriseCoin = _k[0], setProductAriseCoin = _k[1];
    var _l = useState(undefined), product = _l[0], setProduct = _l[1];
    var _m = useState([]), availableElements = _m[0], setAvailableElements = _m[1];
    var _o = useState(null), onSaleOrders = _o[0], setOnSaleOrders = _o[1];
    var _p = useState(null), displayedOnSaleOrders = _p[0], setDisplayedOnSaleOrders = _p[1];
    var _q = useState(null), recentlySoldOrders = _q[0], setRecentlySoldOrders = _q[1];
    var _r = useState(null), displayedRecentlySoldOrders = _r[0], setDisplayedRecentlySoldOrders = _r[1];
    var _s = useState({ cta: undefined, usdc: undefined }), cursors = _s[0], setCursors = _s[1];
    var _t = useState({ cta: -1, usdc: -1 }), remainings = _t[0], setRemainings = _t[1];
    var _u = useState(0), refreshCount = _u[0], setRefreshCount = _u[1];
    var _v = useState(undefined), floorPriceOrder = _v[0], setFloorPriceOrder = _v[1];
    var _w = useState(undefined), supply = _w[0], setSupply = _w[1];
    useEffect(function () {
        setCursors({ cta: undefined, usdc: undefined });
        setRemainings({ cta: -1, usdc: -1 });
    }, [tab]);
    var getProduct = useCallback(function () {
        var _a;
        switch (type) {
            case TokenType.CARD: {
                if (!productCard)
                    return null;
                var relatedContent = [];
                if (((_a = productCard.reagentsIan) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    var _loop_1 = function (ian) {
                        var relatedCard = cardsData.find(function (card) { return card.ian === ian; });
                        if (relatedCard) {
                            relatedContent.push(relatedCard);
                        }
                    };
                    for (var _i = 0, _b = productCard.reagentsIan; _i < _b.length; _i++) {
                        var ian = _b[_i];
                        _loop_1(ian);
                    }
                }
                var foundRelatedProductCards = cardsData.filter(function (card) {
                    var reagentsIan = card.reagentsIan;
                    return reagentsIan.includes(productCard.ian);
                });
                var _loop_2 = function (card) {
                    if (!relatedContent.find(function (_a) {
                        var ian = _a.ian;
                        return ian === card.ian;
                    })) {
                        relatedContent.push(card);
                    }
                };
                for (var _c = 0, foundRelatedProductCards_1 = foundRelatedProductCards; _c < foundRelatedProductCards_1.length; _c++) {
                    var card = foundRelatedProductCards_1[_c];
                    _loop_2(card);
                }
                return productCard
                    ? {
                        type: TokenType.CARD,
                        data: __assign(__assign({}, productCard), { relatedContent: relatedContent }),
                    }
                    : null;
            }
            case TokenType.MINT_PASS: {
                return productMintPass ? { type: TokenType.MINT_PASS, data: productMintPass } : null;
            }
            case TokenType.PRESALE_PACK: {
                return productPresalePack ? { type: TokenType.PRESALE_PACK, data: productPresalePack } : null;
            }
            case TokenType.PRESALE_TICKET: {
                return productPresaleTicket ? { type: TokenType.PRESALE_TICKET, data: productPresaleTicket } : null;
            }
            case TokenType.CHEST: {
                return productChest ? { type: TokenType.CHEST, data: productChest } : null;
            }
            case TokenType.SHARD: {
                return productShard ? { type: TokenType.SHARD, data: productShard } : null;
            }
            case TokenType.SOUVENIR_CARD: {
                return productSouvenirCard ? { type: TokenType.SOUVENIR_CARD, data: productSouvenirCard } : null;
            }
            case TokenType.ARISE_COIN: {
                return productAriseCoin ? { type: TokenType.ARISE_COIN, data: productAriseCoin } : null;
            }
            default: {
                return null;
            }
        }
    }, [
        productCard,
        productMintPass,
        productPresalePack,
        productPresaleTicket,
        productChest,
        productShard,
        productSouvenirCard,
        productAriseCoin,
        type,
    ]);
    var getAvailableElements = useCallback(function () {
        if (!productCard)
            return [];
        var elements = productCard.elements;
        return elements.sort(function (a, b) { return sortedElements.indexOf(a) - sortedElements.indexOf(b); });
    }, [productCard]);
    useEffect(function () {
        setOnSaleOrders(null);
        setDisplayedOnSaleOrders(null);
        setRecentlySoldOrders(null);
        setDisplayedRecentlySoldOrders(null);
        if (tab === MarketDetailsTab.ON_SALE) {
            getOnSaleOrders({ refresh: true });
        }
        else if (tab === MarketDetailsTab.ACTIVITY) {
            getRecentlySoldOrders({ refresh: true });
        }
    }, [
        id,
        product,
        usdcAddress,
        fees,
        imxClient,
        filters.state.currencyTokens,
        filters.state.elements,
        filters.state.grades,
        filters.state.foils,
        filters.state.ranks,
        filters.state.animationLevels,
        tab,
    ]);
    useEffect(function () {
        setProductCard(type === TokenType.CARD ? cardsData.find(function (card) { return card.ian === id; }) : null);
        setProductMintPass(type === TokenType.MINT_PASS ? mintPassesData.find(function (mintPass) { return mintPass.key === id; }) : undefined);
        setProductPresalePack(type === TokenType.PRESALE_PACK ? presalePacksData.find(function (presalePack) { return presalePack.key === id; }) : undefined);
        setProductPresaleTicket(type === TokenType.PRESALE_TICKET
            ? presaleTicketsData.find(function (presaleTicket) { return presaleTicket.key === id; })
            : undefined);
        setProductChest(type === TokenType.CHEST ? chestsData.find(function (chest) { return chest.key === id; }) : undefined);
        setProductShard(type === TokenType.SHARD ? shardsData.find(function (shard) { return shard.key === id; }) : undefined);
        setProductSouvenirCard(type === TokenType.SOUVENIR_CARD
            ? souvenirCardsData.find(function (souvenirCard) { return souvenirCard.id.toString() === id; })
            : undefined);
        setProductAriseCoin(type === TokenType.ARISE_COIN ? ariseCoinData.find(function (ariseCoin) { return ariseCoin.rarity === id; }) : undefined);
    }, [id, type]);
    useEffect(function () {
        setProduct(getProduct());
        setAvailableElements(getAvailableElements());
    }, [
        productCard,
        productPresalePack,
        productPresaleTicket,
        productChest,
        productShard,
        productSouvenirCard,
        productMintPass,
        productAriseCoin,
        getProduct,
        getAvailableElements,
    ]);
    useEffect(function () {
        function getSupply() {
            return __awaiter(this, void 0, void 0, function () {
                var cardSupplyResponse;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!productCard)
                                return [2 /*return*/];
                            return [4 /*yield*/, gqlSdk.MpCardSupplyFindByIan({ input: { ian: productCard.ian } })];
                        case 1:
                            cardSupplyResponse = _a.sent();
                            setSupply(getFormatedSupply(productCard.advancement, cardSupplyResponse.mpCardSupplyFindByIan.cards));
                            return [2 /*return*/];
                    }
                });
            });
        }
        getSupply();
    }, [productCard]);
    useEffect(function () {
        getFloorPrice();
    }, [product, imxClient, usdcAddress, fees]);
    function generateCardImage(applyFilters) {
        var cardElements = productCard ? productCard.elements : [];
        switch (type) {
            case TokenType.CARD: {
                var elements = filters.state.elements.length === 0 || !applyFilters ? cardElements : filters.state.elements;
                var foil = filters.state.foils.length === 0 || !applyFilters ? false : filters.state.foils[0];
                var rank = filters.state.ranks.length === 0 || !applyFilters ? 1 : filters.state.ranks[0];
                var grade = filters.state.grades.length === 0 || !applyFilters ? CardGrade.C : filters.state.grades[0];
                var animationLevel = filters.state.animationLevels.length === 0 ? 1 : filters.state.animationLevels[0];
                return productCard
                    ? generateCardImgUrl(productCard.ian, productCard.advancement, elements, foil, rank, grade, animationLevel)
                    : '';
            }
            case TokenType.MINT_PASS: {
                return productMintPass
                    ? "".concat(appEnv.marketplaceImagesUrl.mintPass).concat(generatePathFromEnum(productMintPass.key), ".png")
                    : '';
            }
            case TokenType.PRESALE_PACK: {
                return productPresalePack
                    ? "".concat(appEnv.marketplaceImagesUrl.presalePack).concat(generatePathFromEnum(productPresalePack.key), ".png")
                    : '';
            }
            case TokenType.PRESALE_TICKET: {
                return productPresaleTicket
                    ? "".concat(appEnv.marketplaceImagesUrl.presaleTicket).concat(generatePathFromEnum(productPresaleTicket.key), ".png")
                    : '';
            }
            case TokenType.CHEST: {
                return productChest ? "".concat(appEnv.marketplaceImagesUrl.chest).concat(generatePathFromEnum(productChest.key), ".png") : '';
            }
            case TokenType.SHARD: {
                return productShard ? "".concat(appEnv.marketplaceImagesUrl.shard).concat(generatePathFromEnum(productShard.key), ".png") : '';
            }
            case TokenType.SOUVENIR_CARD: {
                var foil = filters.state.foils.length === 0 || !applyFilters ? false : filters.state.foils[0];
                return productSouvenirCard ? generateSouvenirCardImgUrl(productSouvenirCard.id, foil) : '';
            }
            case TokenType.ARISE_COIN: {
                return productAriseCoin
                    ? "".concat(appEnv.marketplaceImagesUrl.ariseCoin).concat(generatePathFromEnum(productAriseCoin.rarity), ".png")
                    : '';
            }
            default: {
                return '';
            }
        }
    }
    function getMetadata() {
        var _a;
        switch (type) {
            case TokenType.CARD: {
                if (!productCard)
                    return [];
                var elements = productCard.elements;
                var artists = artistsData;
                return [
                    {
                        icon: rarityAssets[productCard.rarity],
                        label: t('filters.rarity'),
                        value: t("card-metadata.rarity.".concat(productCard === null || productCard === void 0 ? void 0 : productCard.rarity.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: advancementAssets[productCard.advancement],
                        label: t('filters.advancement'),
                        value: t("card-metadata.advancement.".concat(productCard.advancement.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: factionAssets[productCard.faction],
                        label: t('filters.faction'),
                        value: t("card-metadata.faction.".concat(productCard.faction.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: elements.length === 1 ? elementAssets[elements[0]] : '',
                        label: t('filters.element'),
                        value: elements.length === 1
                            ? t("card-metadata.element.".concat(elements[0].toLocaleLowerCase().replaceAll('_', '-')))
                            : t('card-metadata.element.multi'),
                        elements: elements.length > 1 ? elements : undefined,
                    },
                    {
                        icon: cardTypeIcon,
                        label: t('filters.card-type'),
                        value: t("card-metadata.card-type.".concat(productCard.type.toLocaleLowerCase().replaceAll('_', '-'))),
                    },
                    {
                        icon: artistIcon,
                        label: t('common.artist'),
                        value: productCard.artist,
                        link: ((_a = artists[productCard.artist]) === null || _a === void 0 ? void 0 : _a.length) ? artists[productCard.artist] : undefined,
                    },
                ];
            }
            case TokenType.SOUVENIR_CARD: {
                if (!productSouvenirCard)
                    return [];
                return [
                    {
                        icon: gradeAssets[productSouvenirCard.grade],
                        label: t('filters.grade'),
                        value: "".concat(t('common.grade'), " ").concat(productSouvenirCard.grade),
                    },
                ];
            }
            default: {
                return [];
            }
        }
    }
    function getOnSaleOrders(options) {
        return __awaiter(this, void 0, void 0, function () {
            var names, parsedFilters, result, newRefreshCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!usdcAddress || !imxClient || !fees || !product) {
                            return [2 /*return*/];
                        }
                        setImxLoading(true);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        if (type !== TokenType.CARD && type !== TokenType.SOUVENIR_CARD && type !== TokenType.ARISE_COIN) {
                            names = [(product === null || product === void 0 ? void 0 : product.data.name) || ''];
                        }
                        parsedFilters = {
                            tokenType: [type],
                            element: type === TokenType.CARD && filters.state.elements.length > 0 ? filters.state.elements : undefined,
                            grade: type === TokenType.CARD && filters.state.grades.length > 0 ? filters.state.grades : undefined,
                            rank: type === TokenType.CARD && filters.state.ranks.length > 0
                                ? filters.state.ranks.map(function (rank) { return rank.toString(); })
                                : undefined,
                            foil: (type === TokenType.CARD || type === TokenType.SOUVENIR_CARD) && filters.state.foils.length === 1
                                ? filters.state.foils
                                : undefined,
                            animationLevel: type === TokenType.CARD && filters.state.animationLevels.length > 0 ? filters.state.animationLevels : undefined,
                            ian: type === TokenType.CARD ? [id] : undefined,
                            id: type === TokenType.SOUVENIR_CARD ? [id] : undefined,
                            rarity: type === TokenType.ARISE_COIN && productAriseCoin ? [productAriseCoin.rarity] : undefined,
                            name: names,
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, onSaleOrders, type, filters.state.currencyTokens, parsedFilters, 'buy_quantity_with_fees', SortDirection.ASC, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { sellTokenName: filters.state.searchQuery.value }))];
                    case 1:
                        result = _a.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setOnSaleOrders(result.orders);
                        setDisplayedOnSaleOrders(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getRecentlySoldOrders(options) {
        return __awaiter(this, void 0, void 0, function () {
            var names, parsedFilters, result, newRefreshCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!usdcAddress || !imxClient || !fees) {
                            return [2 /*return*/];
                        }
                        setImxLoading(true);
                        setCursors(function (value) { return ((options === null || options === void 0 ? void 0 : options.refresh) ? { cta: undefined, usdc: undefined } : value); });
                        if (type !== TokenType.CARD && type !== TokenType.SOUVENIR_CARD && type !== TokenType.ARISE_COIN) {
                            names = [(product === null || product === void 0 ? void 0 : product.data.name) || ''];
                        }
                        parsedFilters = {
                            tokenType: [type],
                            element: type === TokenType.CARD && filters.state.elements.length > 0 ? filters.state.elements : undefined,
                            grade: type === TokenType.CARD && filters.state.grades.length > 0 ? filters.state.grades : undefined,
                            rank: type === TokenType.CARD && filters.state.ranks.length > 0
                                ? filters.state.ranks.map(function (rank) { return rank.toString(); })
                                : undefined,
                            foil: (type === TokenType.CARD || type === TokenType.SOUVENIR_CARD) && filters.state.foils.length === 1
                                ? filters.state.foils
                                : undefined,
                            animationLevel: type === TokenType.CARD && filters.state.animationLevels.length > 0 ? filters.state.animationLevels : undefined,
                            ian: type === TokenType.CARD ? [id] : undefined,
                            id: type === TokenType.SOUVENIR_CARD ? [id] : undefined,
                            rarity: type === TokenType.ARISE_COIN && productAriseCoin ? [productAriseCoin.rarity] : undefined,
                            name: names,
                        };
                        return [4 /*yield*/, getImxOrders(imxClient, usdcAddress, queue, fees, recentlySoldOrders, type, filters.state.currencyTokens, parsedFilters, 'updated_at', SortDirection.DESC, cursors, (options === null || options === void 0 ? void 0 : options.refresh) ? undefined : remainings, parseCurrencyQuantity, __assign(__assign({}, options), { status: 'filled', sellTokenName: filters.state.searchQuery.value }))];
                    case 1:
                        result = _a.sent();
                        newRefreshCount = (options === null || options === void 0 ? void 0 : options.refresh) ? 1 : refreshCount + 1;
                        setRecentlySoldOrders(result.orders);
                        setDisplayedRecentlySoldOrders(result.orders.length > 200 * newRefreshCount ? __spreadArray([], result.orders, true).slice(0, 200 * newRefreshCount) : result.orders);
                        setCursors(result.cursors);
                        setRemainings(result.remainings);
                        setRefreshCount(newRefreshCount);
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function getFloorPrice() {
        return __awaiter(this, void 0, void 0, function () {
            var floorPriceMetadata, floorPrice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!product || !usdcAddress || !fees)
                            return [2 /*return*/];
                        floorPriceMetadata = {
                            ian: product.type === TokenType.CARD ? product.data.ian : undefined,
                            id: product.type === TokenType.SOUVENIR_CARD ? product.data.id : undefined,
                            name: product.data.name,
                        };
                        return [4 /*yield*/, getAssetFloorPrice(imxClient, usdcAddress, queue, fees, parseCurrencyQuantity, product.type, floorPriceMetadata)];
                    case 1:
                        floorPrice = _a.sent();
                        setFloorPriceOrder(floorPrice);
                        return [2 /*return*/];
                }
            });
        });
    }
    function showFloorPriceBuyNowDialog() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (!floorPriceOrder)
            return;
        var hasEnoughCurrency = checkIfWalletAsEnoughCurrency(user, balances, selectedWallet, localWalletAddress, parseCurrencyQuantity, floorPriceOrder.order.buy.data.token_address || '', floorPriceOrder.order.buy.data.quantity_with_fees);
        var foil = undefined;
        if (floorPriceOrder.card)
            foil = floorPriceOrder.card.foil;
        if (floorPriceOrder.souvenirCard)
            foil = floorPriceOrder.souvenirCard.foil;
        setDialogProps({
            common: {
                preTitle: t('common.about-to-buy'),
                title: ((_a = floorPriceOrder.order.sell.data.properties) === null || _a === void 0 ? void 0 : _a.name) || '',
                close: { text: t('common.cancel'), action: function () { return setDialogProps(undefined); } },
                actions: [
                    {
                        highlighted: true,
                        text: t('common.confirm'),
                        action: hasEnoughCurrency ? floorPriceBuyNow : undefined,
                        disabled: !hasEnoughCurrency || (selectedWallet === null || selectedWallet === void 0 ? void 0 : selectedWallet.address) === floorPriceOrder.order.user,
                    },
                ],
            },
            custom: {
                type: DialogType.BUY_SINGLE_ASSET,
                imgUrl: ((_b = floorPriceOrder.order.sell.data.properties) === null || _b === void 0 ? void 0 : _b.image_url) || '',
                tokenId: floorPriceOrder.order.sell.data.token_id || '',
                tokenAddress: floorPriceOrder.order.sell.data.token_address || '',
                ownerAddress: floorPriceOrder.order.user,
                numbering: ((_c = floorPriceOrder.card) === null || _c === void 0 ? void 0 : _c.numbering) ||
                    ((_d = floorPriceOrder.souvenirCard) === null || _d === void 0 ? void 0 : _d.numbering) ||
                    ((_e = floorPriceOrder.mintPass) === null || _e === void 0 ? void 0 : _e.numbering),
                metadata: {
                    rarity: (_f = floorPriceOrder.card) === null || _f === void 0 ? void 0 : _f.rarity,
                    advancement: (_g = floorPriceOrder.card) === null || _g === void 0 ? void 0 : _g.advancement,
                    element: floorPriceOrder.card ? floorPriceOrder.card.element : undefined,
                    foil: foil,
                    rank: ((_h = floorPriceOrder.card) === null || _h === void 0 ? void 0 : _h.advancement) === CardAdvancement.STANDARD ? (_j = floorPriceOrder.card) === null || _j === void 0 ? void 0 : _j.rank : undefined,
                    grade: ((_k = floorPriceOrder.card) === null || _k === void 0 ? void 0 : _k.grade) || ((_l = floorPriceOrder.souvenirCard) === null || _l === void 0 ? void 0 : _l.grade),
                },
                notEnoughCurrency: !hasEnoughCurrency,
                price: {
                    tokenSymbol: floorPriceOrder.price.address === appEnv.ctaTokenAddress
                        ? CurrencyTokenSymbol.CTA
                        : CurrencyTokenSymbol.USDC,
                    value: ((_m = floorPriceOrder.price.base) === null || _m === void 0 ? void 0 : _m.displayValue) || '',
                    usdValue: ((_o = floorPriceOrder.price.usd) === null || _o === void 0 ? void 0 : _o.displayValue) || '',
                },
            },
        });
    }
    function floorPriceBuyNow() {
        return __awaiter(this, void 0, void 0, function () {
            var error, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedWallet || !floorPriceOrder)
                            return [2 /*return*/];
                        setImxLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, imxActions.createTrade({
                                walletFrom: selectedWallet,
                                orderId: floorPriceOrder.order.order_id,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1.message.includes('USER_VERIFIED_REQUIRED')) {
                                error = t('error.imx.kyc-required');
                            }
                            else if (err_1.message.includes('MPC_WALLET_CTA_TOKEN_IS_LOCKED')) {
                                error = t('error.imx.cta-token-locked');
                            }
                            else if (err_1.message.includes('MPC_WALLET_ASSET_IS_LOCKED')) {
                                error = t('error.imx.asset-locked');
                            }
                            else {
                                error = t('error.generic');
                            }
                            console.log("[buyNow] ".concat(err_1));
                        }
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!error) return [3 /*break*/, 7];
                        return [4 /*yield*/, sleep(4000)];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([getFloorPrice(), getBalances()])];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setImxLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.buy-now'),
                                close: { text: t('common.back'), action: function () { return setDialogProps(undefined); } },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('buy-now.success-message'),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        product: product,
        generateCardImage: generateCardImage,
        availableElements: availableElements,
        metadata: getMetadata(),
        onSaleOrders: displayedOnSaleOrders,
        recentlySoldOrders: displayedRecentlySoldOrders,
        supply: supply,
        floorPriceOrder: floorPriceOrder,
        getOnSaleOrders: getOnSaleOrders,
        showFloorPriceBuyNowDialog: showFloorPriceBuyNowDialog,
    };
}
